import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalComponent } from "components";
import { ThemeService, CommonApi } from "services";
import { logger, modalNotification } from "utils";
import ReportMemorialForm from "components/Form/User/ReportMemorialForm/index.form";

function ReportCategory({ id, showReportModal, setReportModal }) {
  const { t } = useTranslation();

  const [reportCategory, setReportCategory] = useState([]);
  const [reportCategoryLoader, setReportCategoryLoader] = useState(false);

  const getReportCategory = async () => {
    setReportCategoryLoader(true);
    try {
      const res = await ThemeService.GetReportCategoryService();
      const { success, data, message } = res;
      if (data && success) {
        setReportCategory(data?.rows);
      } else {
        modalNotification({
          type: "error",
          message,
        });
      }
    } catch (err) {
      logger(err);
    }
    setReportCategoryLoader(false);
  };
  useEffect(() => {
    if (showReportModal) {
      getReportCategory();
    }
  }, [showReportModal]);

  const handleCloseModalReport = () => {
    setReportModal(false);
  };

  const handleReportMemorial = async (value) => {
    try {
      const bodyData = { ...value, memorialId: id };
      await CommonApi.reportMemorial(bodyData);
      setReportModal(false);
    } catch (err) {
      logger(err);
    }
  };
  return (
    <>
      <ModalComponent
        show={showReportModal}
        size="md"
        title="Report Biography"
        closeButton="true"
        modalExtraClass="reportModal"
        extraTitleClassName="reportModal_title"
        onHandleCancel={handleCloseModalReport}
      >
        {" "}
        <ReportMemorialForm
          setReportModal={setReportModal}
          onSubmit={handleReportMemorial}
          t={t}
          reportCategory={reportCategory}
          reportCategoryLoader={reportCategoryLoader}
        />
      </ModalComponent>
    </>
  );
}

export default ReportCategory;
